export const BLUE = '#4290f5';
